/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Dropdown, Image, Row, Tag } from "antd";
import {
  AmountIcon,
  CrossIcon,
  DeleteIcon,
  PenIcon,
  StarFilledIcon,
} from "../../../../atoms/CustomIcons";

import { useEffect, useRef, useState } from "react";
import { SelectedContactType } from "../../ducks/types";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { PopUp } from "../../../../atoms/PopUp";
import AddContactPopUp from "./PopUp";
import { SelectFieldWithButton } from "../../../../atoms/FormFields";
import { MoreOutlined } from "@ant-design/icons";

interface PropsType {
  propertyContact: {
    label: string;
    value: string;
  }[];
  clientId: string | null;
  companyId: string;
  control: any;
  clientContactData: [];
  contactData?: [] | undefined;
  selectedClient: string | undefined;
}

export default function PropertyContact(props: PropsType) {
  const {
    propertyContact,
    clientId,
    companyId,
    clientContactData,
    control,
    contactData,
    selectedClient,
  } = props;
  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [newContactPopUp, setNewContact] = useState<boolean>(false);
  const [contactIndex, setContactIndex] = useState<null | number>(null);
  const [tableRecord, setTableRecord] = useState<any>(null);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedContact, setSelectedContact] = useState<
    SelectedContactType[] | null
  >(null);

  console.log("contactIndex", contactIndex, tableRecord);

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            setNewContact(true);
            e.stopPropagation();
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<CrossIcon />}
        >
          Remove from property
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const deleteFunction = () => {
    console.log("Delete function");
    setLoading(true);
  };

  const addNewContact = {
    visibility: newContactPopUp,
    class: "",
    content: (
      <AddContactPopUp
        onClose={() => setNewContact(false)}
        companyId={companyId}
        clientId={clientId}
      />
    ),
    width: 541,
    onCancel: () => {
      setNewContact(false);
    },
  };

  const confirmDeletePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete ? <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const contactChange = (value: string | number | readonly string[]) => {
    const filteredContact: SelectedContactType[] | null =
      clientContactData?.filter(
        (emp: { id: string }) =>
          Array.isArray(value) && value.some((v) => v === emp?.id)
      ) ?? null;

    setSelectedContact(filteredContact ?? null);
  };

  useEffect(() => {
    if (contactData && contactData?.length > 0) {
      const filteredContact: SelectedContactType[] | null =
        clientContactData?.filter(
          (emp: { id: string }) =>
            Array.isArray(contactData) &&
            contactData?.some(
              (v: { client_contact_id: string }) =>
                v?.client_contact_id === emp?.id
            )
        ) ?? null;

      setSelectedContact(filteredContact ?? null);
    }
  }, [contactData, clientContactData]);
  return (
    <>
      <Row gutter={20}>
        <Col span={24} style={{ marginBottom: "16px" }}>
          <h4 style={{ marginBottom: "4px" }}> Property contacts </h4>
          <p>People at the property your team coordinates and works with.</p>
        </Col>

        <Col span={24} style={{ marginBottom: "12px" }}>
          <SelectFieldWithButton
            fieldName="client_contact_id"
            control={control}
            selectOption={propertyContact}
            iProps={{
              placeholder: "Select existing or create a new one",
              mode: "multiple",
              disabled: selectedClient ? false : true,
            }}
            addItemText="Add new contact"
            onAddItemClick={() => setNewContact(true)}
            onSelectChange={contactChange}
          />
          {!selectedClient && (
            <p
              style={{ color: "#474C4D", fontSize: "11px", marginTop: "-16px" }}
            >
              Select client first. All property contacts belong to its client.
            </p>
          )}
        </Col>
        {selectedClient && (
          <Col span={24}>
            {selectedContact && selectedContact?.length > 0 ? (
              <div className="contact_wrapper">
                {selectedContact?.map((contact, i) => (
                  <Card key={contact?.id}>
                    <div className="titleBar">
                      <span className="userName">
                        {`${contact?.first_name ?? ""} ${
                          contact?.last_name ?? ""
                        }`}
                      </span>
                      <div className="actionBtns">
                        <Button type="text">
                          <StarFilledIcon />
                        </Button>
                        <Button type="text">
                          <PenIcon />
                        </Button>
                        <Button type="text">
                          <AmountIcon />
                        </Button>

                        <Dropdown
                          menu={{ items }}
                          trigger={["click"]}
                          placement="bottomRight"
                          className="actionButton"
                        >
                          <Button
                            onClick={(x) => {
                              x.stopPropagation();
                              setContactIndex(i);
                              setTableRecord(contact);
                            }}
                            onKeyDown={(e) => e.stopPropagation()}
                            style={{
                              padding: "0px",
                              height: "auto",
                              border: "unset",
                              backgroundColor: "transparent",
                            }}
                            ref={dropdownRef}
                            className="only_icon"
                            icon={<MoreOutlined />}
                          />
                        </Dropdown>
                      </div>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <Tag
                        className="purple_tag"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "inline-block",
                          minWidth: "auto",
                          maxWidth: "100%",
                        }}
                      >
                        {contact?.title}
                      </Tag>
                    </div>
                    <div className="contactData">
                      <span className="labelText">Phone:</span>
                      <span className="ValueText">{contact?.phone}</span>
                    </div>

                    <div className="contactData">
                      <span className="labelText">Email:</span>
                      <span className="ValueText">{contact?.email}</span>
                    </div>
                  </Card>
                ))}
              </div>
            ) : (
              <div className="whenEmpty">
                <Image
                  src="/images/empty-icons/no-active.svg"
                  preview={false}
                />
                <h3> Property has no contacts </h3>
                <p> Enter the contact name in the field above </p>
              </div>
            )}
          </Col>
        )}
      </Row>

      <PopUp {...addNewContact} />
      <PopUp {...confirmDeletePopUp} />
    </>
  );
}
